/*
 * Kanzi — quick add from the product card
 * ---------------------------------------------------------------
 * Modelled on about---blank.com, measured 27 Jul 2026:
 *
 *   - No size swatches under the card. Sizes are a decision, and a
 *     decision belongs at the moment of buying, not in a grid where the
 *     shopper is still browsing.
 *   - A small "+" on the photo opens a panel over the bottom of THAT
 *     card. Not a full-screen modal — the shopper never loses their
 *     place in the grid.
 *   - Sizes render as one connected strip. Sold-out sizes stay visible
 *     but struck through, because "they had it, just not in my size" is
 *     information; a missing button is a mystery.
 *   - The button says "select size" before a size is chosen. It tells
 *     you what to do instead of failing when you press it.
 *
 * Data is fetched per product on first open (/products/{handle}.js) and
 * cached, so a 40-product collection page costs nothing until someone
 * actually reaches for a size.
 */
(function () {
  var KZ = window.KZ || {};
  var money = typeof KZ.money === 'function' ? KZ.money : function (m) { return m; };

  var SIZE_RE = /^(xxs|xs|s|m|l|xl|xxl|xxxl|2xl|3xl|one size|o\/s|os|\d{2,3})$/i;
  var cache = {};

  /* ── which option is the size one ───────────────────────────── */
  function sizeIndex(product) {
    var byName = product.options.findIndex(function (o) {
      return /size|مقاس/i.test(typeof o === 'string' ? o : o.name);
    });
    if (byName > -1) return byName;
    /* fall back to whichever option's values look like sizes */
    for (var i = 0; i < product.options.length; i++) {
      var vals = product.variants.map(function (v) { return v.options[i]; });
      if (vals.some(function (v) { return SIZE_RE.test(String(v).trim()); })) return i;
    }
    return -1;
  }

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').split('?')[0].match(/\/products\/([^\/?#]+)/);
    return m ? { handle: m[1], href: a.getAttribute('href') } : null;
  }

  /* /products/{handle}.js carries no inventory_policy and no variant
     image, so pre-orders are invisible to it and the sheet had nothing
     to show. templates/product.kzdata.liquid returns both. If that
     template is ever missing we fall back to the built-in endpoint —
     the sheet then loses the image and pre-order labelling, but still
     sells. */
  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '?view=kzdata')
      .then(function (r) { if (!r.ok) throw new Error('no kzdata'); return r.json(); })
      .catch(function () {
        return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
      })
      .then(function (p) { cache[handle] = p; return p; });
  }

  /* ── panel ──────────────────────────────────────────────────── */

  /* v49: close everything, everywhere.
     The old version removed one panel, one backdrop, and the open flag
     from the ONE card it was handed. That leaks. Open card A's sheet,
     then tap card B's + : build(B) calls close(B), which finds no panel
     inside B, falls back to the document, and removes A's panel — but
     A KEEPS ITS .kzq-open CLASS. From then on A is permanently flagged
     open, so the next tap on A's + hits the toggle branch, calls close,
     and returns without opening. It takes two taps to open A, forever.
     The same leak explains a sheet that opens once and then refuses.
     Nothing here needs to be selective, so nothing is. */
  function close(card) {
    document.querySelectorAll('.kzq').forEach(function (p) { p.remove(); });
    document.querySelectorAll('.kzq-backdrop').forEach(function (b) { b.remove(); });
    document.querySelectorAll('.kzq-open').forEach(function (c) { c.classList.remove('kzq-open'); });
    document.querySelectorAll('.kzq-open-btn.is-busy').forEach(function (b) { b.classList.remove('is-busy'); });
    document.documentElement.style.overflow = '';
    if (card && card.classList) card.classList.remove('kzq-open');
  }

  function build(card, product, info, forceSheet) {
    close(card);

    var si = sizeIndex(product);
    if (si < 0) return;                       // nothing to choose

    /* Respect the colour the card is showing: prefer the variant in the
       card's own link, else the first available one. */
    var current = null;
    var m = info.href.match(/variant=(\d+)/);
    if (m) current = product.variants.find(function (v) { return String(v.id) === m[1]; });
    if (!current) current = product.variants.find(function (v) { return v.available; }) || product.variants[0];

    var siblings = product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return i === si || o === current.options[i]; });
    });

    var panel = document.createElement('div');
    panel.className = 'kzq';

    var head = document.createElement('div');
    head.className = 'kzq__head';

    /* A shopper choosing a size should be able to see the thing they
       are choosing it for — especially from a grid, where the sheet
       covers the photo they just tapped. */
    var thumbSrc = current.image || product.featured;
    if (thumbSrc) {
      var thumb = document.createElement('img');
      thumb.className = 'kzq__thumb';
      thumb.src = thumbSrc;
      thumb.alt = '';
      thumb.loading = 'lazy';
      head.appendChild(thumb);
    }

    var text = document.createElement('div');
    text.className = 'kzq__text';
    text.innerHTML = '<span class="kzq__name"></span>' +
      '<a class="kzq__link" href="' + info.href + '">view product &rarr;</a>';
    text.querySelector('.kzq__name').textContent = product.title;
    head.appendChild(text);

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'kzq__x';
    x.setAttribute('aria-label', 'Close');
    x.innerHTML = '&times;';
    x.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(card); });
    head.appendChild(x);

    var strip = document.createElement('div');
    strip.className = 'kzq__sizes';

    var chosen = null;
    siblings.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kzq__size' + (v.available ? '' : ' is-out') + (v.preorder ? ' is-pre' : '');
      b.textContent = v.options[si];
      if (!v.available) {
        b.disabled = true;
        b.title = 'Sold out';
      } else {
        if (v.preorder) b.title = 'Pre-order';
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          strip.querySelectorAll('.kzq__size').forEach(function (o) { o.classList.remove('is-on'); });
          b.classList.add('is-on');
          chosen = v;
          cta.classList.add('is-ready');
          /* Pre-order is a different promise from "in stock". Say so on
             the button itself, and again underneath, before they pay. */
          label.textContent = v.preorder ? 'pre-order' : 'add to bag';
          note.textContent = v.preorder ? 'Made to order — ships when back in stock.' : '';
          note.hidden = !v.preorder;
        });
      }
      strip.appendChild(b);
    });

    var note = document.createElement('p');
    note.className = 'kzq__note';
    note.hidden = true;

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'kzq__cta';
    var price = document.createElement('span');
    price.className = 'kzq__price';
    price.textContent = money(current.price);
    var label = document.createElement('span');
    label.className = 'kzq__label';
    label.textContent = 'select size';
    cta.appendChild(price);
    cta.appendChild(label);

    cta.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (!chosen) {                       // nudge rather than fail silently
        strip.classList.remove('kzq__sizes--ask');
        void strip.offsetWidth;
        strip.classList.add('kzq__sizes--ask');
        return;
      }
      label.textContent = chosen.preorder ? 'reserving…' : 'adding…';
      add(chosen.id).then(function () {
        /* The tick belongs HERE — after something is genuinely in the
           bag — not on a button press that only opened this sheet. */
        cta.classList.add('is-done');
        label.textContent = chosen.preorder ? 'reserved' : 'added';
        setTimeout(function () { close(card); }, 750);
      }).catch(function () { label.textContent = 'try again'; });
    });

    panel.appendChild(head);
    panel.appendChild(strip);
    panel.appendChild(note);
    panel.appendChild(cta);

    /* On a phone the panel is a sheet fixed to the bottom of the SCREEN,
       so it belongs to the document, not to a card that is half a screen
       wide. On desktop it sits over its own card. */
    /* forceSheet: opened from the product page, where there is no card
       to hang off — always the bottom sheet, at any width. */
    var sheet = forceSheet || window.matchMedia('(max-width: 767px)').matches;
    if (sheet) {
      /* Say it in the DOM. The stylesheet used to work this out for
         itself from a media query and disagreed with us above 767px. */
      panel.classList.add('kzq--sheet');
      var backdrop = document.createElement('div');
      backdrop.className = 'kzq-backdrop';
      backdrop.addEventListener('click', function () { close(card); });
      document.body.appendChild(backdrop);
      document.body.appendChild(panel);
      document.documentElement.style.overflow = 'hidden';
    } else {
      var img = card.querySelector('img');
      var host = img && img.parentElement ? img.parentElement : card;
      host.appendChild(panel);
    }
    card.classList.add('kzq-open');
  }

  /* ── adding ─────────────────────────────────────────────────── */

  function drawer() { return document.querySelector('dialog.cart-drawer__dialog'); }

  function add(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        /* Ritual's cart drawer listens for CartAddEvent, whose event name
           is ThemeEvents.cartUpdate === 'cart:update'. Dispatching it lets
           the theme open and refresh its own drawer instead of us
           reaching into its internals. */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'kanzi-quick-add',
            data: { source: 'quick-add', itemCount: cart.item_count }
          }
        }));

        /* If the theme didn't open the drawer, make sure the shopper
           still sees what just happened. */
        setTimeout(function () {
          var d = drawer();
          if (d && d.open) return;
          var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
          if (trigger) trigger.click(); else window.location.href = '/cart';
        }, 700);
      });
  }

  /* ── reacting to the + ──────────────────────────────────────────
     The button itself is rendered in Liquid now. This file used to walk
     every card on the page and inject one, on a MutationObserver
     watching document.body with subtree:true — so it re-ran on every
     image load and every app injection, and the buttons visibly popped
     in after the grid had painted.

     One delegated listener replaces all of it. It costs nothing until
     someone actually taps. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.kzq-open-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var card = btn.closest('product-card, .product-card');
    if (!card) return;
    if (card.classList.contains('kzq-open')) { close(card); return; }

    var info = { handle: btn.dataset.kzqHandle, href: btn.dataset.kzqHref || '' };
    if (!info.handle) return;

    btn.classList.add('is-busy');
    load(info.handle)
      .then(function (p) { build(card, p, info); })
      .catch(function () { if (info.href) window.location.href = info.href; })
      .then(function () { btn.classList.remove('is-busy'); });
  });

  /* Sizes don't belong on a card. One pass on load — the app renders its
     swatches once, and a permanent observer to catch it was never worth
     what it cost. */
  function hideSizeSwatches() {
    document.querySelectorAll('product-card .globo-swatch-list label[for], .product-card .globo-swatch-list label[for]')
      .forEach(function (lb) {
        var input = document.getElementById(lb.htmlFor);
        if (!input || !SIZE_RE.test(String(input.value).trim())) return;
        lb.style.display = 'none';
      });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(hideSizeSwatches, 400); });
  } else {
    setTimeout(hideSizeSwatches, 400);
  }

  /* ── shared with the product page ───────────────────────────────
     On about:blank the PDP has no size selector in the buy box either —
     "add to bag" opens this same sheet. One component, one behaviour, so
     a shopper who learns it in the grid already knows it on the product
     page. */
  window.KZ = window.KZ || {};
  window.KZ.openSizeSheet = function (opts) {
    var host = opts.card || document.body;
    return load(opts.handle).then(function (p) {
      build(host, p, {
        href: (opts.href || ('/products/' + opts.handle)) +
              (opts.variantId ? '?variant=' + opts.variantId : '')
      }, !opts.card);
    });
  };

  /* click away / escape closes the open panel */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.kzq')) return;
    document.querySelectorAll('.kzq-open').forEach(close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.kzq-open').forEach(close);
  });
})();
